export const NAME = 'shoppingCart';